module.exports = (Promise.resolve(__parcel__require__("./" + "RistrettoBroadcasting.a3d843f4.cd84fe70.js"))).then(() => parcelRequire('bnyPA'));